import { ResponsiveImage } from "@quintype/components";
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { removeHtmlTags } from "../../../arrow/utils/utils";

import { Carousel } from "../../atoms";

import "./new-image-gallery.m.css";

const NewImageGallery = ({ element }) => {
  const imageArr = element["story-elements"];

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const imageCard = (image, index) => {
    return (
      <div key={index}>
        <div styleName="image-count">
          <div styleName="box">
            <span styleName="count">
              {index + 1}/{imageArr.length}
            </span>
          </div>
        </div>
        <ResponsiveImage
          slug={image["image-s3-key"]}
          metadata={image["image-metadata"]}
          alt={removeHtmlTags(image["alt-text"]) || removeHtmlTags(image.title)}
          title={removeHtmlTags(image.title) || removeHtmlTags(image["alt-text"])}
          aspectRatio={null}
          imgParams={{ auto: ["format", "compress"], fit: "fill", q: 70 }}
          styleName="image"
          shouldDecodeImage={true}
          widths={[360, 640]}
          defaultWidth={640}
        />
        {(image.title || image["image-attribution"]) && (
          <div styleName="caption">
            {removeHtmlTags(image.title)}
            {image["image-attribution"] ? ` ${image.title ? "/" : ""}Credits: ` : ""}
            {removeHtmlTags(image["image-attribution"])}
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      styleName={`image-gallery-container ${
        qtState?.data?.story?.["is-live-blog"] ? "live-blog-conatiner-image-gallery" : ""
      } `}
    >
      <div styleName="gallery-count">Gallery ({imageArr.length} Photos)</div>
      <div styleName="carousel-container">
        <Carousel itemWidth={588} gap={8} showDots={false} showButtons={true} maxItemWidth={588} itemMobileWidth={334}>
          {imageArr?.map((image, index) => imageCard(image, index))}
        </Carousel>
      </div>
    </div>
  );
};

NewImageGallery.propTypes = {
  element: PropTypes.shape({
    "story-elements": PropTypes.array,
  }),
};

export default NewImageGallery;
